import { ExpenseEntry } from "../models/expense-entry.model";
import { UuidAndId } from "../models/uuid-and-id";
import { ExpenseEntryStateModel } from "../state/expense-entry.state";

export namespace ExpenseEntryActions {
    export class Refresh {
        static readonly type = '[API-EXPENSE-ENTRY] Refresh'
        constructor() {}
    }
    export class IncrementPendingCount {
        static readonly type = '[Network Service-EXPENSE-ENTRY] Increment Pending Count'
        constructor() {}
    } 
    export class Init {
        static readonly type = '[Storage-EXPENSE-ENTRY] Init'
        constructor(public payload: ExpenseEntryStateModel) {}
    }
    export class Set {
        static readonly type = '[API-EXPENSE-ENTRY] Set'
        constructor(public payload: ExpenseEntry[]) {}
    }
    export class Merge {
        static readonly type = '[API-EXPENSE-ENTRY] Merge'
        constructor(public payload: ExpenseEntry[]) {}
    }
    export class AddOne {
        static readonly type = '[UI-EXPENSE-ENTRY] Add One'
        constructor(public payload: ExpenseEntry) {}
    }    
    export class UpdateOne {
        static readonly type = '[UI-EXPENSE-ENTRY] Update One'
        constructor(public payload: ExpenseEntry) {}
    }       
    export class DeleteOne {
        static readonly type = '[UI-EXPENSE-ENTRY] Delete One'
        constructor(public payload: ExpenseEntry) {}
    }     
    export class ApiAddedOne {
        static readonly type = '[API-EXPENSE-ENTRY] Added One'
        constructor(public payload: ExpenseEntry) {}
    }
    export class ApiUpdatedOne {
        static readonly type = '[API-EXPENSE-ENTRY] Updated One'
        constructor(public payload: ExpenseEntry) {}
    }
    export class ApiDeletedOne {
        static readonly type = '[API-EXPENSE-ENTRY] Deleted One'
        constructor(public payload: UuidAndId) {}
    }     
}
